<template>
    <!-- <b-row align-h="between" class="e-ticket-type-card">
        <b-col cols="12" md="auto" class="m-ticket-title">
            <h3 class="m-ticket-type">{{title}}</h3>
            <span class="m-ticket-subtitle">{{getCurrencyString(subtitle)}}</span>
        </b-col>
        <b-row cols="4" align-h="around" align-v="center" class="m-ticket-button-group">
            <b-col cols="2"><b-button :disabled="internalTicketTotal == 0" class="m-ticket-add-subtract-btn" @click="subtract">-</b-button></b-col>
            <b-col cols="2" ><span class="m-ticket-total">{{internalTicketTotal}}</span></b-col>
            <b-col class="pl-0" cols="2"><b-button class="m-ticket-add-subtract-btn" @click="add">+</b-button></b-col> 
        </b-row>
    </b-row> -->

<div class="ticket" v-bind:class="{'has-quantity': hasQty, disabled: internalDisabled}">
  <div class="ticket__meta">
    <h3 class="ticket__name">{{title}}</h3>
    <div class="ticket__prices">
      <!-- <span class="ticket__from-price">$19.99</span>
      <span>-</span>
      <span class="ticket__to-price">$39.99</span>
      <br class="u-d-none-sm"> -->
      <span>from {{getCurrencyString(subtitle)}}  </span>
      <br class="u-d-none-sm">
      <span class="ticket__promo">10% off</span>
    </div>
  </div>

  <div class="ticket__quantity">
    <button class="ticket__quantity__control ticket__quantity__control--decrement control" aria-label="Decrement" :disabled="internalTicketTotal == 0" @click="decrement">
      <span class="control__text"><span class="u-sr">Decrement</span>-</span>
    </button>
    <div class="ticket__quantity__control ticket__quantity__control--input" >{{internalTicketTotal}}</div>
    <!--  TODO FIX THIS INPUT ISSUE<input class="ticket__quantity__control ticket__quantity__control--input" type="number" v-model.number="internalTicketTotal"/> -->
    <button class="ticket__quantity__control ticket__quantity__control--increment control" aria-label="Increment" @click="increment">
      <span class="control__text"><span class="u-sr">Increment</span>+</span>
    </button>
  </div>

</div>
</template>

<script>

export default {
    name: 'TicketControl',
    props: ['title', 'subtitle', 'ticket', 'qty', 'disabled', 'priceHigh', 'priceLow', 'age', 'discount'], //ticketTypes is a "ticketGroup" - collection of ticket types related to the same event
    data: function() {
        return {
            internalTicketTotal: this.qty
        }
    },
    computed: {
        hasQty() {
            return this.internalTicketTotal > 0;
        },
        internalDisabled() {
            if(this.disabled) {
                return disabled;
            } else {
                return false;
            }
        }
    },
    methods: {
        getCurrencyString: function(value) {
            return '$' + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        },
        increment: function(event) {
            this.internalTicketTotal += 1;
            this.$emit('update:qty', this.internalTicketTotal);
        },

        decrement: function(event) {
            if(this.internalTicketTotal > 0) {
                this.internalTicketTotal -= 1;
                this.$emit('update:qty', this.internalTicketTotal);
            }
        }
    }
}
</script>

<style lang="scss">


</style>
